export const INTERNAL_JSON_RPC_ERROR = 'Internal JSON-RPC error.' 